module.exports = __webpack_public_path__ + "image/icon_apply_enterprise.png";